import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//  Get All
export const GetAll = createAsyncThunk(
    "masters/turntable_spin/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Masters.Turntable_spin}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Get Single
export const GetSingle = createAsyncThunk(
    "masters/turntable_spin/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.Masters.Turntable_spin}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

//  Create (Add)
export const Create = createAsyncThunk(
    "masters/turntable_spin/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(APIS.Masters.Turntable_spin, data);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

//  Update
export const Update = createAsyncThunk(
    "masters/turntable_spin/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${APIS.Masters.Turntable_spin}/${id}`, data);
            if (res?.success)
                return res;
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

//  Delete
export const Delete = createAsyncThunk(
    "masters/turntable_spin/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${APIS.Masters.Turntable_spin}/${id}`);
            return id; // Return the id of the deleted country
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

//  Status
export const Status = createAsyncThunk(
    "masters/turntable_spin/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.Turntable_spin}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "turntable_spins",
    initialState: {
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, Update, Delete
            .addCase(GetAll.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAll.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAll.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSingle.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Create.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Create.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(Create.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (country) => country.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (country) => country.id !== action.payload.id
                ); // Remove the country with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (country) => country.id !== action.payload.id
                ); // Remove the country with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
